export const arrayToSelectObject = (values, funcs) => {
  let finalObject = null;
  if (values) {
    let index = 0;
    finalObject = values.map((value) => {
      return {
        value,
        func: funcs && funcs[index] ? funcs[index++] : () => {},
      };
    });
  }
  return finalObject;
};

export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties,
  };
};

export const callBifrost = (link) => {
  console.log("bifrost call");
  console.log(link);
};

// [important] HAVE TO BE "!="  because its compare null AND undefined
// [important] "!==" its compare ONLY IF null
export const checkExist = (item) => {
  return item != null;
};

export const checkValidLink = (item) => {
  return item != null && (item === true || item === false);
};

// Monta as opções do filtro (ícone de funil) de uma coluna da Table do antd,
// com os valores únicos de `field` em `rows` no formato { text, value }.
// Usado em:
// - containers/Afinando/Events/columns.js
// - containers/Afinando/Events/RankingEventModal/columns.js
// - containers/Afinando/Events/StoreEventModal/columns.js
// - containers/Audbility/AudbilityUsers/columns.js
export const buildFilters = (rows, field) =>
  Array.from(new Set(rows.map((row) => row[field])))
    .filter(Boolean)
    .map((value) => ({
      text: value,
      value,
    }));

export const getKeyGen = (key = "") => {
  return key + Math.random() + new Date().getMilliseconds();
};

export const getSplitedDate = (date) => {
  date = date.replace(" ", "T");
  const FormattedDate = new Date(date);
  let day = FormattedDate.getDate();
  day = day < 10 ? "0" + day : day;
  // getMonth() return (0 - 11)
  let month = FormattedDate.getMonth() + 1;
  month = month < 10 ? "0" + month : month;
  return [day, month, FormattedDate.getFullYear()];
};

export const sortByAttributeID = (list, att = "name", notReverse = true) => {
  if (list && att) {
    list = list.sort((patA, patB) => {
      return parseInt(patA[att]) < parseInt(patB[att]) ? 1 : -1;
    });

    if (notReverse) list = list.reverse();
  }
  return list;
};

export const sortByAttribute = (list, att = "name", notReverse = true) => {
  if (list && att) {
    list = list.sort((patA, patB) => {
      return patA[att] < patB[att] ? 1 : -1;
    });

    if (notReverse) list = list.reverse();
  }
  return list;
};

export const sortByInnerAttribute = (
  list,
  firstAtt = "",
  secondtAtt = "",
  notReverse = true
) => {
  if (list && firstAtt && secondtAtt) {
    list = list.sort((patA, patB) => {
      return patA[firstAtt][secondtAtt] < patB[firstAtt][secondtAtt] ? 1 : -1;
    });

    if (notReverse) list = list.reverse();
  }
  return list;
};

export const simplestText = (text = null) => {
  if (text) {
    text = text.toString().toLowerCase();
    text = text.replace(new RegExp("[ÁÀÂÃÄ]", "gi"), "a");
    text = text.replace(new RegExp("[ÉÈÊË]", "gi"), "e");
    text = text.replace(new RegExp("[ÍÌÎÏ]", "gi"), "i");
    text = text.replace(new RegExp("[ÓÒÔÕÖ)]", "gi"), "o");
    text = text.replace(new RegExp("[ÚÙÛÜ]", "gi"), "u");
    text = text.replace(new RegExp("[Ç]", "gi"), "c");
  }
  return text;
};

export const openExternalLink = (link) => {
  const win = window.open(link, "_blank");
  win.focus();
};

export const checkIsNewHelper = (date, name) => {
  date = new Date(date).getTime();
  const today = new Date().getTime();
  const diffDays = parseInt((today - date) / (1000 * 60 * 60 * 24), 10);
  return diffDays < 31;
};

export const checkIsEqualText = (textA, textB) => {
  return simplestText(textA) === simplestText(textB);
};

export const checkIsEqualNumber = (numberA, numberB) => {
  return parseInt(numberA) === parseInt(numberB);
};

export const checkListSize = (list, att) => {
  if (att) return list && list[att] && list[att].length > 0;
  else return list && list.length > 0;
};

// Convert H:M:S to seconds
// Seconds are optional (i.e. n:n is treated as h:s)
const hmsToSeconds = (s) => {
  var b = s.split(":");
  return b[0] * 60 + (+b[1] || 0);
};

// Convert seconds to hh:mm:ss
// Allow for -ve time values
const secondsToHMS = (secs) => {
  function z(n) {
    return (n < 10 ? "0" : "") + n;
  }
  var sign = secs < 0 ? "-" : "+";
  secs = Math.abs(secs);
  return sign + z(((secs % 3600) / 60) | 0) + ":" + z(secs % 60);
};

export const twoDigits = (day = "") =>
  day.toString().length < 2 ? "0" + day : day;

export const diffInMinutes = (firstTime = "00:00", secondTime = "00:00") => {
  secondTime = hmsToSeconds(secondTime);
  firstTime = hmsToSeconds(firstTime);
  return secondsToHMS(secondTime - firstTime);
};

export const shortText = (text = "") => {
  let tempBody = text;
  if (text.length > 150) {
    tempBody = text.substr(0, 150);
    if (
      tempBody[tempBody.length - 1] === " " ||
      tempBody[tempBody.length - 1] === "."
    )
      tempBody = text.substr(0, 149);
    tempBody = tempBody + "...";
  }
  return tempBody;
};

export const getColorByLetters = (name = "-") => {
  // let letterA = "";
  // let notFound = [133, 172, 172];
  // let finalColor = "rgba(133, 172, 172)";

  // if (name[0]) letterA = simplestText(name[0]);

  // const dictionary = {
  //   a: [165, 165, 115],
  //   b: [185, 185, 228],
  //   c: [235, 170, 170],
  //   d: [184, 224, 184],
  //   e: [219, 100, 100],
  //   f: [136, 192, 192],
  //   g: [236, 236, 161],
  //   h: [67, 201, 201],
  //   i: [192, 192, 192],
  //   j: [231, 165, 231],
  //   k: [84, 84, 209],
  //   l: [123, 224, 123],
  //   m: [128, 128, 128],
  //   n: [223, 185, 115],
  //   o: [219, 110, 110],
  //   p: [127, 255, 212],
  //   q: [243, 149, 115],
  //   r: [189, 88, 189],
  //   s: [245, 222, 179],
  //   t: [70, 168, 70],
  //   u: [182, 84, 104],
  //   v: [240, 230, 140],
  //   w: [255, 192, 203],
  //   x: [209, 105, 209],
  //   y: [221, 160, 221],
  //   z: [196, 196, 78],
  // };

  // let colorA = dictionary[letterA];
  // if (!colorA) colorA = notFound;

  // const colorMixC = colorA[0];
  // const colorMixM = colorA[1];
  // const colorMixY = colorA[2];
  // finalColor = "rgb(" + colorMixC + ", " + colorMixM + ", " + colorMixY + ")";
  // finalColor = "#fdfdfd";

  // return finalColor;
  return "#fdfdfd";
};

export const nextEncode = (data) => {
  let dataToRetun =
    Buffer.from(data, "utf8").toString("base64") +
    Buffer.from("afinando_next", "utf8").toString("base64");
  return Buffer.from(dataToRetun, "utf8").toString("base64");
};

export const nextDecode = (data) => {
  let afinando_next = Buffer.from("afinando_next", "utf8").toString("base64");
  data = Buffer(data, "base64").toString();
  data = data.replace(afinando_next, "");
  return Buffer(data, "base64").toString();
};

/**
 *
 * @param {0 - 100} score
 * @description return a objecjet {color: hexa, colorBorder: hexa}, red / yellow / green
 */
export const getColorsScores = (score) => {
  score = parseInt(score);
  let color = "#e6ffdc";
  let colorBorder = "#24660a";
  if (score < 50) {
    color = "#ffcdcd";
    colorBorder = "#d6373a";
  } else if (score >= 50 && score <= 80) {
    color = "#ffffcb";
    colorBorder = "#c5a82f";
  }
  return {
    color: color,
    colorBorder: colorBorder,
  };
};

export const getArrayPlaysNotPaid = () => {
  let finalPlays = [];
  for (let index = 1; index <= 10; index++) {
    finalPlays.push({
      date_updated: "01/01/2050 00:00:00",
      game_id: "XX" + index,
      game_level: 1,
      id: "XX" + index,
      name: "Xxxxxxxxxx",
      play_score: 10 * index,
      play_time: "XX:XX",
    });
  }
  return finalPlays;
};

export const checkIsIos = () => {
  return (
    [
      "iPad Simulator",
      "iPhone Simulator",
      "iPod Simulator",
      "iPad",
      "iPhone",
      "iPod",
    ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  );
};

export const checkPasswordValidations = (pw = null) => {
  let validation = {
    hasLowercase: false,
    hasUppercase: false,
    hasNumber: false,
    hasMinEight: false,
  };

  const listLowercase = "qwertyuiopasdfghjklçzxcvbnm";
  const listUppercase = "QWERTYUIOPASDFGHJKLÇZXCVBNM";
  pw = pw.replace(/[ÁÀÂÃÄ]/g, "A");
  pw = pw.replace(/[ÉÈÊË]/g, "E");
  pw = pw.replace(/[ÍÌÎÏ]/g, "I");
  pw = pw.replace(/[ÓÒÔÕÖ]/g, "O");
  pw = pw.replace(/[ÚÙÛÜ]/g, "U");
  pw = pw.replace(/[Ç]/g, "C");
  pw = pw.replace(/[áàâãä]/g, "a");
  pw = pw.replace(/[éèêë]/g, "e");
  pw = pw.replace(/[íìîï]/g, "i");
  pw = pw.replace(/[óòôõö]/g, "o");
  pw = pw.replace(/[úùûü]/g, "u");
  pw = pw.replace(/[ç]/g, "c");

  if (pw) {
    validation.hasNumber = pw.replace(/\D/g, "").length > 0;
    validation.hasMinEight = pw.length >= 8;

    [...pw].forEach((char) => {
      if (!validation.hasLowercase)
        validation.hasLowercase = listLowercase.includes(char);
      if (!validation.hasUppercase)
        validation.hasUppercase = listUppercase.includes(char);
    });
  }
  return validation;
};

export const getLabelLeverOrBonusLevel = (play = "", level) => {
  let label = "global.level_" + level;
  if (play && play.bonus_level && play.bonus_level !== "") {
    label = play.bonus_level;
  }
  return label;
};
